import {
  useQuery,
  useMutation,
  useQueryClient,
  useInfiniteQuery,
} from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";

import * as api from "apis/overtimeComponent";

export function useOvertimeComponentTypes(payload = {}, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["overtimesComponentTypes/pagination", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOvertimeComponentTypes(payload);
        response = data;
      } catch (error) {}
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useOvertimeComponentTypesSuggestion = (
  payload = {},
  options = {}
) => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useInfiniteQuery(
    ["overtimesComponentTypes/suggestion", payload],
    async ({ pageParam = 1 }) => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOvertimeComponentTypes({
          page: pageParam,
          ...payload,
        });
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      getNextPageParam: (lastPage) => {
        if (!lastPage) {
          return undefined;
        }
        return lastPage.current_page < lastPage.last_page
          ? lastPage.current_page + 1
          : undefined;
      },
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
};

export function useOvertimeComponentType(payload = {}, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["overtimesComponentType", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOvertimeComponentType(payload);
        response = data;
      } catch (error) {}
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useOvertimeComponentTypeEmployee(payload = {}, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["overtimesComponentType/employee", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getOvertimeComponentTypeEmployee(payload);
        response = data;
      } catch (error) {}
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useAddOvertimeComponentType = () => {
  const { message } = App.useApp();
  return useMutation((payload) => api.addOvertimeComponentType(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
  });
};

export const useEditOvertimeComponentType = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  return useMutation((payload) => api.editOvertimeComponentType(payload), {
    onSuccess: ({ data }, payload) => {
      if (data?.success) {
        queryClient.invalidateQueries([
          "overtimesComponentType",
          { id: payload?.id },
        ]);
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
  });
};

export const useDeleteOvertimeComponentType = () => {
  const { message } = App.useApp();
  return useMutation((payload) => api.deleteOvertimeComponentType(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
  });
};
